export const DATA_ROOT = '/data'

// 2026-05-31 IA Round 2 Wave 4: data input 3종(sources, dbConnector,
// integrationConsole)은 Designer section으로 이동. /designer/data-sources,
// /designer/db-connector, /designer/integration-console에서 진입한다.
// Data 메뉴는 실행 결과물(ABox + lineage)만 유지.
export const DATA_ROUTES = {
  hub: '/data/hub',
  objects: '/data/objects',
  lineage: '/data/lineage',
  streamingBackfill: '/data/streaming-backfill',
  canvas: '/data/canvas',
  viewer: '/data/viewer',
  trinoConnector: '/data/connectors/trino',
} as const

export const DESIGNER_ROUTES = {
  root: '/designer',
  aiBuild: '/designer/ai-build',
  dataSources: '/designer/data-sources',
  dbConnector: '/designer/db-connector',
  integrationConsole: '/designer/integration-console',
  sparqlSources: '/designer/sparql-sources',
  ragManagement: '/designer/rag-management',
  policyAuthoring: '/designer/policy-authoring',
} as const

export const AUTO_INSIGHT_ROUTES = {
  root: '/auto-insight',
  reportLibrary: '/auto-insight/report-library',
  reportBuilder: '/auto-insight/bi-report-builder',
} as const

export const PROJECT_ROUTES = {
  root: '/projects',
  readyMadePacks: '/projects/ready-made-packs',
  onboarding: '/projects/onboarding',
} as const

export const SETTINGS_ROUTES = {
  root: '/settings',
  users: '/settings/users',
  credentialVault: '/settings/credential-vault',
  auditLogs: '/settings?view=audit-logs',
} as const

export type DataMenuKey =
  | 'data-hub'
  | 'objects-relations'
  | 'lineage'
  | 'streaming-backfill'
  | 'data-canvas'
  | 'data-viewer'

export const DATA_ROUTE_ALIASES: Record<string, DataMenuKey> = {
  '': 'data-hub',
  hub: 'data-hub',
  objects: 'objects-relations',
  lineage: 'lineage',
  'streaming-backfill': 'streaming-backfill',
  canvas: 'data-canvas',
  viewer: 'data-viewer',
}

export const dataMenuFromPath = (pathname: string): DataMenuKey => {
  const trimmed = pathname.replace(/^\/+|\/+$/g, '')
  const segments = trimmed.split('/')
  const dataIndex = segments.indexOf('data')
  const segment = dataIndex >= 0 ? (segments[dataIndex + 1] ?? '') : ''
  return DATA_ROUTE_ALIASES[segment] ?? 'data-hub'
}

export const buildDataObjectsRoute = (
  searchParams?: URLSearchParams
): string => {
  const query = searchParams?.toString()
  return query ? `${DATA_ROUTES.objects}?${query}` : DATA_ROUTES.objects
}
